'use client';

import React from 'react';
import { Slide } from '@/shared/types';

// Interfaces and types
interface TitlePaneProps {
  slide: Slide;
}

// Component definition
const TitlePane: React.FC<TitlePaneProps> = ({
  slide
}) => {
  // Initialize state
  return <h1 className='overflow-x-auto overflow-y-hidden slide-boxes mini sm:lg m-0 text-white text-[22px] sm:text-3xl font-normal sm:font-bold sm:w-[100%-60px] mb-[10px] sm:mb-[30px]' data-sentry-component="TitlePane" data-sentry-source-file="titlePane.tsx">{slide.slideTitle || slide.slideSubTitle}</h1>;
};
export default TitlePane;